export const isSuccess = (code?: number): boolean => {
  return typeof code === 'number' && code >= 200 && code < 300
}

export const isClientError = (code?: number): boolean => {
  return typeof code === 'number' && code >= 400 && code < 500
}

export const isServerError = (code?: number): boolean => {
  return typeof code === 'number' && code >= 500
}

export interface AppHttpError {
  responseCode: number
  message: string
  serviceData?: any
  data?: any
  headers?: any
  config?: any
}

export const toAppHttpError = (res: any): AppHttpError => {
  return {
    responseCode: res?.status ?? 500,
    message: res?.data?.message ?? res?.statusText ?? 'Request failed',
    serviceData: res?.data?.serviceData,
    data: res?.data,
    headers: res?.headers,
    config: res?.config,
  }
}


